/** 安装包只接受 .tgz（大小写不敏感）。 */
export function isTgzFile(file: Pick<File, 'name'>): boolean {
  return file.name.toLowerCase().endsWith('.tgz')
}
